import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';

/** 발전소 이름 수정 입력 — 정보 상세 rename 시트. `plantIdName` 만 부분 전송. */
export interface UpdatePlantNameInput {
  plantId: string;
  /** 새 발전소 이름(plantIdName). */
  plantName: string;
}

/**
 * 발전소 이름 수정 mutation — `PUT /plants/{id}/profile`(plant.plantIdName 만 부분 전송, 구앱 rename 정합).
 * 성공 시 발전소 목록·프로필 캐시 무효화(이름은 목록·상세 양쪽 표기). `toRaw` 정책상 wire 합성은 훅
 * inline([[feedback_no_toraw_mapper]]).
 */
export function useUpdatePlantNameMutation() {
  const api = useApiAppLegacy();
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdatePlantNameInput>({
    mutationFn: async ({ plantId, plantName }) => {
      await api.plant.updateProfile(Number(plantId), {
        profile: { plant: { plantIdName: plantName } },
      });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ['plants'] });
      void queryClient.invalidateQueries({ queryKey: ['plant'] });
    },
  });
}
